export const environment = {
  production: true,
  consoleLog: false,
  ga_measurementid: 'G-ZQDXZL8T8W',
  google_client_id: '702340380982-n8bic8m0n1bi9fk11sqkqjglssu6h0f9.apps.googleusercontent.com',
  redirect_uri: 'https://sidronline.com/token',
  roleModuleDisabled: true
};
